const TableState = require('../../model/TableState');

const API_ENDPOINT_COUNTRIES = 'countries';
const API_ENDPOINT_CUSTOMER = 'procurement/customers';
const API_ENDPOINT_BILLING = 'billingAccounts';
const API_ENDPOINT_PROCUREMENT_ACCOUNTS = 'procurement/accounts';
const SERVER_API = 'api/v1/';

const ARRAYBUFFER_TYPE = 'arraybuffer';

class RegistrationPersistenceService {
    constructor($q, $http, config, sharedPersistenceService, storageService) {
        this._$q = $q;
        this._$http = $http;
        this.config = config;
        this.serverUrl = storageService.getManagerHostname();
        this.registryUrl = config.registryUrl;
        this.REST_ENDPOINTS = sharedPersistenceService.getRestEndpoints();
    }

    setIdToken(id_token) {
        this.id_token = id_token;
    }

    getIdToken() {
        return this.id_token;
    }

    getClientId() {
        return this.config.clientId;
    }

    getServerUrl() {
        return this.serverUrl;
    }

    getOAuthPermissionScopes() {
        return this.config.oAuthPermissionScopes;
    }

    get(request) {
        let req = {
            method: 'GET',
            url: this.registryUrl + SERVER_API + request,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.id_token,
                'If-Modified-Since': '0'
            }
        };
        return this.handleResponse(req);
    }

    post(request, data) {
        let req = {
            method: 'POST',
            url: this.registryUrl + SERVER_API + request,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.id_token
            }
        };
        if (data) req.data = data;
        return this.handleResponse(req);
    }

    login(code) {
        return this.get(`auth/login?code=${code}`).then((res) => {
            return res.data.entities;
        })
    }

    // triggerSSE(fID) {
    //     return this.get(`saasSubscriptions/${fID}/makeKlemenHappy`).then((res) => {
    //         return res.data;
    //     })
    // }

    handleResponse(req) {
        return this._$q((resolve, reject) => this._$http(req).then(resp => {
            if (resp.data) {
                resp.data.tableState = resp.data.metadata && resp.data.metadata !== null ? TableState.fromRaw(resp.data.metadata) : null;
            }
            resolve(resp);
        }, err => resolve(err)
        ));
    }

    getCountries() {
        return this.get(API_ENDPOINT_COUNTRIES).then(res => {
            return res.data.entities;
        })
    }

    registerCustomer(postData) {
        return this.post(API_ENDPOINT_CUSTOMER, postData).then((res) => {
            return res.data.items;
        })
    }

    getBillingPlans() {
        return this.get(API_ENDPOINT_BILLING + ':dropdown').then(res => {
            return res.data.items.map((element, index) => {
                return {
                    id: index,
                    label: element.label,
                    value: element.value.billingAccountId
                }
            });
        })
    }

    resolveDeploy(data) {
        return this.post('saasSubscriptions/resolve', data).then(res => {
            return res.data
        })
    }

    activateDeploy(fID, data) {
        return this.post(`saasSubscriptions/${fID}/activate`, data).then(res => {
            return res.data
        })
    }

    startDeploy(data) {
        return this.post(`deployments/submit`, data).then(res => {
            return res.data
        });
    }

    getSubscription() {
        return this.get(`subscriptions`).then(res => {
            return res.data.entities;
        })
    }

    assignBillingAccount(procurementAccountId, data) {
        return this.post(API_ENDPOINT_PROCUREMENT_ACCOUNTS + `/${procurementAccountId}:assignBillingAccount`, data).then(res => {
            return res.data.items;
        })
    }

}

RegistrationPersistenceService.$inject = ['$q', '$http', 'config', 'sharedPersistenceService', 'storageService'];

module.exports = RegistrationPersistenceService;


// WEBPACK FOOTER //
// ./src/azurebackup/views/registration/registration.persistence.service.js